/** @prettier */

export const canUseLocalStorage = !!(
  typeof window !== 'undefined' &&
  !!window.localStorage &&
  typeof localStorage.getItem === 'function' &&
  typeof localStorage.setItem === 'function' &&
  typeof localStorage.removeItem === 'function'
);
